module.exports = __webpack_public_path__ + "img/gallery_icon.3682496b.png";